import { CARD_ENROLL_EVENTS } from '../constants/common-enums';
import isEmptyObject from './is-empty-object';
import isEmptyString from './is-empty-string';

const isCountryCodeMatchFromBillingAddress = (countryCode, acceptedBillingCountries) => {
  if (acceptedBillingCountries.length) {
    return acceptedBillingCountries.includes(countryCode);
  }
  //When billing address not present(eg: V-SRCi flow), should launch VISA DCF.
  //Accepted billing countries will be present when onboard a Merchant
  return undefined;
};

/** To handle Unsupported Billing/Shipping address scenario:
 *  1. Check response contains no 'PENDING_AVS' for pendingEvents with dpaAccepted false and srcCorrelationId
 *  2. Check if there's difference in countryCode between dpaAcceptedBillingCountries and countryCode from BillingAddress
 * @param {object} response
 * @param {object} dpaTransactionOptions
 * @returns {boolean}
 */
const isCardEnrollError = (response, dpaTransactionOptions) => {
  if (!isEmptyObject(response)) {
    const { PENDING_AVS } = CARD_ENROLL_EVENTS;
    const {
      customOutputData: { dpaAccepted },
      maskedCard,
      srcCorrelationId
    } = response;
    const dpaAcceptedBillingCountries = dpaTransactionOptions?.dpaAcceptedBillingCountries ?? [];
    const countryCodeFromBillingAddress =
      maskedCard?.maskedBillingAddress?.countryCode.toUpperCase() ?? null;
    const pendingEvents =
      (Array.isArray(maskedCard?.digitalCardData?.pendingEvents) &&
        maskedCard.digitalCardData.pendingEvents) ||
      [];
    //Billing address not present always(eg: V-SRCi flow), should launch VISA DCF
    const isCountryCodeMatch = countryCodeFromBillingAddress
      ? isCountryCodeMatchFromBillingAddress(
          countryCodeFromBillingAddress,
          dpaAcceptedBillingCountries
        )
      : undefined;
    const isPendingAvsPresent = pendingEvents.includes(PENDING_AVS);
    if (dpaAccepted === false) {
      return (
        (!isEmptyString(srcCorrelationId) && !isPendingAvsPresent) ||
        (isCountryCodeMatch !== undefined && !isCountryCodeMatch)
      );
    }
  }
  return false;
};

export default isCardEnrollError;
